import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { ProviderRoutingModule } from './provider-routing.module';
import { ProviderCardCollectionComponent } from './components/provider-card-collection/provider-card-collection.component';
import { ProviderCardComponent } from './components/provider-card/provider-card.component';
import { ProviderSearchComponent } from './components/provider-search/provider-search.component';
import { ProviderComponent } from './pages/provider/provider.component';
import { ProviderSiteComponent } from './components/provider-site/provider-site.component';

@NgModule({
    declarations: [
        ProviderSearchComponent,
        ProviderComponent,
        ProviderCardCollectionComponent,
        ProviderCardComponent,
        ProviderSiteComponent
    ],
    imports: [CommonModule, ProviderRoutingModule, SharedModule]
})
export class ProviderModule {}
